export default __webpack_public_path__ + "static/media/bash-icon.60fecc4a.svg";